export default {
    _prefix: "AiScoringStatus",
    label: "AI Scoring",
    status: {
        questionCount: (data: { count: number }) => {
            return "{{count}} question(s) answered";
        },
        tooltipText: (data: {
            answeredQuestionCount: number;
            totalQuestionCount: number;
        }) => {
            return "AI successfully answered {{answeredQuestionCount}} of {{totalQuestionCount}} question(s)";
        },
        lastProcessed: (data: { dateLastChanged: string }) => {
            return "Last processed {{dateLastChanged}}";
        },
        processing:
            "Processing evaluation. User-entered answers will not be replaced.",
        reprocessing:
            "Reprocessing evaluation. User-entered answers will not be replaced.",
    },
};
